/* Embroidery Inc homepage 2026-10, hero C (sections/ei-hero-c.liquid).
   All hero motion is CSS. This file only:
   1. pauses the main hat's float while the hero is off screen or the tab is hidden;
   2. smooth-scrolls the in-page links (Shop by category, Bulk savings) below the sticky header.
   Without it every link still works as a normal #anchor jump. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ei-hero-c]');
  if (!root) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function calm() {
    return !!(mq && mq.matches) || !!(navigator.connection && navigator.connection.saveData);
  }

  var offscreen = false;
  function sync() { root.classList.toggle('is-paused', offscreen || document.hidden); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      offscreen = !entries[entries.length - 1].isIntersecting;
      sync();
    }).observe(root);
  }
  document.addEventListener('visibilitychange', sync);

  /* Sections marked data-ei-cv use content-visibility: auto, so one that has not been shown yet only
     holds an estimated height. Render the ones above the target first so the scroll lands exactly. */
  function settle(target) {
    var cv = document.querySelectorAll('[data-ei-cv]');
    for (var i = 0; i < cv.length; i++) {
      if (cv[i].compareDocumentPosition(target) & 4) cv[i].style.contentVisibility = 'visible';
    }
  }

  function stickyOffset() {
    var el = document.querySelector('store-header[data-is-sticky]');
    while (el && el !== document.body) {
      var pos = window.getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        var r = el.getBoundingClientRect();
        return r.bottom > 0 ? r.height : 0;
      }
      el = el.parentElement;
    }
    return 0;
  }

  var links = root.querySelectorAll('a[data-ei-hc-scroll]');
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (e) {
      var href = this.getAttribute('href') || '';
      var at = href.indexOf('#');
      if (at < 0 || href.length - at < 2) return;
      var hash = href.slice(at);
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      settle(target);
      var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
      window.scrollTo({ top: Math.max(0, y), behavior: calm() ? 'auto' : 'smooth' });
      if (window.history && history.pushState) history.pushState(null, '', hash);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (err) { /* older browsers */ }
    });
  }
})();
